// src/apiPublic.js
//
// Phase 16 (Public Form Links). A SEPARATE axios instance for the
// unauthenticated /api/public/form-access/:token/* endpoints — deliberately
// does NOT reuse src/api.js's instance, because that one always attaches
// the private session JWT (see its request interceptor) and, on any 401,
// clears localStorage and redirects to /login (see its response
// interceptor). Neither behavior is correct here: a public form link must
// never send the viewer's own session token (if they happen to be logged
// in elsewhere in the same browser) as part of proving who THIS link
// belongs to, and an invalid/expired/revoked public link is not a
// "session expired" situation — src/pages/public/PublicFormPage.jsx handles
// those states itself, on its own dedicated screens, never via a redirect
// to /login.
import axios from "axios";
import * as Constants from "./constants/constants";

const apiPublic = axios.create({
  baseURL: Constants.API_URL,
  timeout: 20000,
});

export default apiPublic;
